import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementSearch'], () => {
  return {
    $formkit: 'search',
  }
})
